export default "__VITE_ASSET__Dz0gpW2t__"